import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_BASE_URL, FILE_BASE_URL } from "../apiConfig";
import BannerPageTitle from "../Components/UIcomponents/BannerPageTitle";

function AccountingPage() {
    const [selectedPdf, setSelectedPdf] = useState("");
    const [accountingStatements, setAccountingStatements] = useState([]);
    const iframeRef = useRef(null);

    const isMobile = window.innerWidth <= 768;

    const styles = {
        iframe: {
            width: '100%',
            height: '80vh',
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
            marginTop: '1rem'
        },
        card: {
            width: isMobile ? '100%' : '200px',
            height: '100px',
            background: 'var(--blue)',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
            cursor: 'pointer',
            textAlign: 'center',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            padding: '1rem',
            flexShrink: 0,
        },
        activeCard: {
            background: 'var(--yellow)',
            color: 'var(--blue)',
        },
        cardContainer: {
            display: 'flex',
            flexWrap: isMobile ? 'wrap' : 'nowrap',
            gap: '1rem',
            marginBottom: '2rem',
            overflowX: isMobile ? 'visible' : 'auto',
            paddingBottom: '1rem'
        },
        yearText: {
            fontWeight: '900',
            fontSize: '1.25rem',
        },
        statementText: {
            marginTop: '0.25rem',
            fontSize: '14px',
        },
    };

    useEffect(() => {
        axios.get(`${API_BASE_URL}/accounts`)
            .then((response) => {
                const accounts = response.data.accounts.map((account) => ({
                    year: account.year,
                    pdfUrl: `${FILE_BASE_URL}/accounts/${account.pdf}`,
                }));
                setAccountingStatements(accounts);
                if (accounts.length > 0) {
                    setSelectedPdf(accounts[0].pdfUrl); // Default to first
                }
            })
            .catch((error) => {
                console.error("Error fetching accounting statements:", error);
            });
    }, []);

    const handleCardClick = (pdfUrl) => {
        setSelectedPdf(pdfUrl);
        if (isMobile && iframeRef.current) {
            window.scrollTo({
                top: iframeRef.current.offsetTop - 80,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div style={{ background: '#f4f6fa', minHeight: '100vh', paddingBottom: '4rem' }}>
            <BannerPageTitle 
                title='Accounting' 
                subtitle='Transparent financial reporting for BTCL'
            />
            <div style={{ 
                maxWidth: 'var(--maxWidth)', 
                margin: '-40px auto 0 auto', 
                padding: '3rem 2.5rem', 
                minHeight: '50vh', 
                background: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                zIndex: 10,
                borderTop: '4px solid var(--blue)'
            }}>
                <div style={styles.cardContainer} className="hide-scroll">
                    {accountingStatements.map((statement, index) => (
                        <div
                            key={index}
                            style={{
                                ...styles.card,
                                ...(selectedPdf === statement.pdfUrl ? styles.activeCard : {}),
                            }}
                            onClick={() => handleCardClick(statement.pdfUrl)}
                        >
                            <span style={styles.yearText}>{statement.year}</span>
                            <span style={styles.statementText}>Accounting Statement</span>
                        </div>
                    ))}
                </div>

                {selectedPdf && (
                    <div style={{ padding: isMobile ? '0' : '0 1rem' }}>
                        <iframe
                            ref={iframeRef}
                            src={selectedPdf}
                            style={styles.iframe}
                            title="Accounting Section PDF"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default AccountingPage;
